// extracted by mini-css-extract-plugin
export default {"nav":"Navbar_nav__3tIpP","list":"Navbar_list__4pzcf","skip-link":"Navbar_skip-link__8u-yB"};